module.exports = __webpack_public_path__ + "img/library.298b5b55.svg";